var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66406 3L7.16406 2L6.16406 1.5L7.16406 1L7.66406 0L8.16406 1L9.16406 1.5L8.16406 2L7.66406 3ZM3.16406 5L2.32031 3.34375L0.664062 2.5L2.32031 1.6875L3.16406 0L3.97656 1.6875L5.66406 2.5L3.97656 3.34375L3.16406 5ZM3.16406 2C2.88281 2 2.66406 2.25 2.66406 2.5C2.66406 2.78125 2.88281 3 3.16406 3C3.41406 3 3.66406 2.78125 3.66406 2.5C3.66406 2.25 3.41406 2 3.16406 2ZM14.1641 9L14.9766 10.6875L16.6641 11.5L14.9766 12.3438L14.1641 14L13.3203 12.3438L11.6641 11.5L13.3203 10.6875L14.1641 9ZM14.1641 12C14.4141 12 14.6641 11.7812 14.6641 11.5C14.6641 11.25 14.4141 11 14.1641 11C13.8828 11 13.6641 11.25 13.6641 11.5C13.6641 11.7812 13.8828 12 14.1641 12ZM16.3516 2.4375C16.7578 2.84375 16.7578 3.46875 16.3516 3.875L4.50781 15.7188C4.28906 15.9062 4.03906 16 3.78906 16C3.53906 16 3.28906 15.9062 3.07031 15.7188L0.945312 13.5938C0.539062 13.1875 0.539062 12.5625 0.945312 12.1562L12.7891 0.3125C13.0078 0.125 13.2578 0 13.5078 0C13.7578 0 14.0078 0.125 14.2266 0.3125L16.3516 2.4375ZM3.78906 15L11.8516 6.9375L9.72656 4.8125L1.66406 12.875L3.78906 15ZM12.5703 6.21875L15.6641 3.15625L13.5078 1L10.4453 4.09375L12.5703 6.21875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.ddec86e61ecc2bde66a8a28897755222.svg";
export { ForwardRef as ReactComponent };